import React from 'react';
import { Shield, Mail, MessageCircle } from 'lucide-react';

const FooterEN = () => {
  return (
    <footer className="bg-black text-gray-300 border-t border-red-900/20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets-wrfwihn1.emergentagent.net/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/3s7e8l1h_logodas.png" 
                alt="Cloud Cheats Logo" 
                className="h-10 w-10 object-contain"
              />
              <div>
                <span className="gaming-title text-white text-lg glow-red">CLOUD</span>
                <span className="gaming-title text-red-600 text-lg ml-1">CHEATS</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              The best panels and cheats for Free Fire. Dominate the game with safety and 24/7 dedicated support.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4 gaming-title text-sm">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/en/products" className="hover:text-red-500 transition-colors flex items-center group">
                  <span className="w-1 h-1 bg-red-600 rounded-full mr-2 group-hover:w-2 transition-all"></span>
                  Products
                </a>
              </li>
              <li>
                <a href="/en/feedbacks" className="hover:text-red-500 transition-colors flex items-center group">
                  <span className="w-1 h-1 bg-red-600 rounded-full mr-2 group-hover:w-2 transition-all"></span>
                  Feedbacks
                </a>
              </li>
              <li>
                <a href="/en/cart" className="hover:text-red-500 transition-colors flex items-center group">
                  <span className="w-1 h-1 bg-red-600 rounded-full mr-2 group-hover:w-2 transition-all"></span>
                  Cart
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4 gaming-title text-sm">Support</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 bg-red-600/20 rounded-lg flex items-center justify-center group-hover:bg-red-600/30 transition-colors">
                  <MessageCircle className="w-4 h-4 text-red-500" />
                </div>
                <span className="text-gray-400">24/7 Support via Discord</span>
              </div>
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 bg-red-600/20 rounded-lg flex items-center justify-center group-hover:bg-red-600/30 transition-colors">
                  <Mail className="w-4 h-4 text-red-500" />
                </div>
                <span className="text-gray-400">support@cloudcheats.com</span>
              </div>
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 bg-red-600/20 rounded-lg flex items-center justify-center group-hover:bg-red-600/30 transition-colors">
                  <Shield className="w-4 h-4 text-red-500" />
                </div>
                <span className="text-gray-400">Secure Payment</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-red-900/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              &copy; {new Date().getFullYear()} Cloud Cheats. All rights reserved.
            </p>
            <p className="text-xs text-gray-600">
              Built to dominate Free Fire
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterEN;
